import { render, staticRenderFns } from "./BlinkingCursorText.vue?vue&type=template&id=0c27b58d&scoped=true&"
import script from "./BlinkingCursorText.vue?vue&type=script&lang=js&"
export * from "./BlinkingCursorText.vue?vue&type=script&lang=js&"
import style0 from "./BlinkingCursorText.vue?vue&type=style&index=0&id=0c27b58d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c27b58d",
  null
  
)

export default component.exports